module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.site) ? _c('section', {
    attrs: {
      "id": "intro"
    }
  }, [_c('header', {
    on: {
      "click": function($event) {
        return _vm.$router.push({
          name: 'Collections'
        })
      }
    }
  }, [_c('transition', {
    attrs: {
      "name": _vm.titleTransition
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.siteIntro && !_vm.notesVisible),
      expression: "!siteIntro && !notesVisible"
    }],
    staticClass: "title"
  }, [_c('h1', {
    staticClass: "h1"
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'Collections'
      }
    }
  }, [_vm._v(_vm._s(_vm.headerText))])], 1), _vm._v(" "), _c('h2', {
    staticClass: "h5 century-mono"
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'Collections'
      }
    }
  }, [_vm._v(_vm._s(_vm.subheaderText))])], 1)])]), _vm._v(" "), _c('cinemagraph', {
    attrs: {
      "site": _vm.site,
      "blur": _vm.siteIntro || _vm.notesVisible || _vm.blurVideo
    },
    on: {
      "playing": _vm.cinemagraphPlaying
    }
  })], 1), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [_c('router-view', {
    attrs: {
      "mobile": _vm.mobile,
      "site": _vm.site
    }
  })], 1), _vm._v(" "), _c('transition', {
    attrs: {
      "name": _vm.titleTransition
    }
  }, [_c('router-link', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.siteIntro),
      expression: "!siteIntro"
    }],
    staticClass: "intro__asterisk",
    attrs: {
      "to": {
        name: 'Notes'
      }
    }
  }, [_c('span', {
    staticClass: "icon-asterisk"
  })])], 1)], 1) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-027ef4d0"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Intro.vue
// module id = 369
// module chunks = 1